module.exports = __webpack_public_path__ + "img/Dream gaming.cd735a54.jpg";